module.exports = __webpack_public_path__ + "static/media/discord.dac30ded.png";